// JOBE-0105: RecentActivityBlock — side-rail block on the /projects
// index. UI mock; renders three static placeholder rows shaped per the
// wireframe (AGENT → project · action · entity-type · time · RUN/HUMAN
// badge). The block header carries a `Preview` pill with a tooltip
// ("Project activity feed — coming soon") per spec §Decision 4 + the
// rollout's Out-of-scope list.
//
// No fetch; no state; deterministic render. When the real feed lands,
// the block swaps its data source and drops the pill — no other change.

import React from 'react';

const MOCK_ROWS = [
  {
    actor: 'iris',
    action: 'put_entity',
    target: 'listing',
    when: '2m',
    role: 'RUN',
  },
  {
    actor: 'shawn',
    action: 'reassign_owner',
    target: 'project',
    when: '17m',
    role: 'HUMAN',
  },
  {
    actor: 'router',
    action: 'commit',
    target: 'document',
    when: '1h',
    role: 'RUN',
  },
];

export function RecentActivityBlock() {
  return (
    <section
      className="projects-rail-block projects-rail-recent-activity"
      data-testid="projects-rail-recent-activity"
    >
      <header className="projects-rail-block-header">
        <h3 className="projects-rail-block-title">Recent activity</h3>
        <span
          className="projects-rail-preview-pill"
          data-testid="projects-rail-preview-pill"
          title="Project activity feed — coming soon"
        >
          Preview
        </span>
      </header>
      <ul className="projects-rail-activity-list">
        {MOCK_ROWS.map((row, idx) => (
          <li
            key={idx}
            className="projects-rail-activity-row"
            data-testid={`projects-rail-activity-row-${idx}`}
          >
            <span className="projects-rail-activity-line">
              <span className="projects-rail-activity-actor">{row.actor}</span>
              {' · '}
              <span className="projects-rail-activity-action">{row.action}</span>
              {' · '}
              <span className="projects-rail-activity-target muted">{row.target}</span>
            </span>
            <span className="projects-rail-activity-meta muted">
              <span className="projects-rail-activity-when">{row.when}</span>
              {' '}
              <span className={`projects-rail-activity-role projects-rail-activity-role-${row.role.toLowerCase()}`}>
                {row.role}
              </span>
            </span>
          </li>
        ))}
      </ul>
    </section>
  );
}
